import { MedicalCenter } from '../models/medical-center.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MessageService } from './message.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Page } from '../models/page.model';
import { tap } from 'rxjs/operators';
import { User } from '../models/user.model';
import { environment } from '@environments/environment';

export interface MedicalCenterRequest {
    code: string;
    descr: string;
    indirizzo: string;
    luogo: string;
    provincia: string;
}

export interface MedicalCenterUserRequest {
    username: string;
}

@Injectable({
    providedIn: 'root'
  })
  export class MedicalCenterService {

    private currentCenterSubject: BehaviorSubject<MedicalCenter>;
    currentCenter: Observable<MedicalCenter>;

    readonly defaultSort = [{paramName: 'descr', sortDirection: 'ASC'}];

    private readonly baseUrl = `${environment.http.apiRoot}/medicalCentres`;

    constructor(private http: HttpClient, private messageService: MessageService) {
    }

    getMedicalCenter(medCenterId: number): Observable<MedicalCenter> {
        return this.http.get<MedicalCenter>(`${this.baseUrl}/${medCenterId}`);
    }

    getMedicalCenterList(params: HttpParams): Observable<Page<MedicalCenter>> {
        return this.http.get<Page<MedicalCenter>>(this.baseUrl, {params});
    }

    createMedicalCenter(medicalCenterRequest: MedicalCenterRequest): Observable<MedicalCenter> {
        return this.http.post<MedicalCenter>(this.baseUrl, medicalCenterRequest).pipe(
            tap(res => this.messageService.handleSuccess('MEDICAL_CENTERS.MESSAGES.CREATE.SUCCESS'))
        );
    }

    updateMedicalCenter(medCenterId: number, medicalCenterRequest: MedicalCenterRequest): Observable<MedicalCenter> {
        return this.http.put<MedicalCenter>(`${this.baseUrl}/${medCenterId}`, medicalCenterRequest).pipe(
            tap(res => this.messageService.handleSuccess('MEDICAL_CENTERS.MESSAGES.UPDATE.SUCCESS'))
        );
    }

    deleteMedicalCenter(medCenterId: number): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/${medCenterId}`).pipe(
            tap(res => this.messageService.handleSuccess('MEDICAL_CENTERS.MESSAGES.DELETE.SUCCESS'))
        );
    }

    getAssignableUsers(params: HttpParams): Observable<Page<User>> {
        return this.http.get<Page<User>>(`${this.baseUrl}/assignableUsers`, {params});
    }

    addUser(medCenterId: number, medicalCenterUserRequest: MedicalCenterUserRequest): Observable<MedicalCenter> {
        return this.http.post<MedicalCenter>(`${this.baseUrl}/${medCenterId}/users`, medicalCenterUserRequest).pipe(
            tap(res => this.messageService.handleSuccess('MEDICAL_CENTERS.MESSAGES.UPDATE.SUCCESS'))
        );
    }

    removeUser(medCenterId: number, username: number): Observable<MedicalCenter> {
        return this.http.delete<MedicalCenter>(`${this.baseUrl}/${medCenterId}/users/${username}`).pipe(
            tap(res => this.messageService.handleSuccess('MEDICAL_CENTERS.MESSAGES.UPDATE.SUCCESS'))
        );
    }

    getCurrentCenter(): Observable<MedicalCenter> {
        return this.http.get<MedicalCenter>(`${this.baseUrl}/current`);
    }
}
